// 事件
export const clickEvent = {
  switchlanguage_webclick: "switchlanguage_webclick", // 切换语言

  // 头部点击
  header_home_click: "header_home_click", // 头部 首页 点击
  header_demand_click: "header_demand_click", // 头部 需求方 点击
  header_provision_click: "header_provision_click", // 头部 服务方 点击
  header_regarding_click: "header_regarding_click", // 头部 关于平台 点击
  header_shopping_click: "header_shopping_click", // 头部 商城服务 点击
  login_webclick: "login_webclick", // 登录
  demand_webclick: "demand_webclick", // 登录弹窗 - 需求方
  provision_webclick: "provision_webclick", // 登录弹窗 - 服务商

  // 首页banner内按钮点击
  home_banner_btnclick: "home_banner_btnclick", // 头部 关于平台 点击
  // 首页点击
  home_demand_btnclick: "home_demand_btnclick", // 首页 需求方按钮
  home_provision_btnclick: "home_provision_btnclick", // 首页 服务方按钮
  // 需求方页面点击
  go_demand_btnclick: "go_demand_btnclick", // 需求方页面 跳转按钮
  // 服务方页面点击
  go_provision_btnclick: "go_provision_btnclick", // 服务商页面 跳转按钮
};
